<template>
    <Layout>
        <PageHeader :title="title" :items="items" /> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-phone bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">Phone Number Tags</h5>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-sm-12 text-right">
                            <div class="input-group">
                                <input
                                id="search"
                                type="text"
                                class="form-control"
                                v-model="searchKey"
                                placeholder="+628.."
                                aria-describedby="search"
                                @keyup.enter="searchPhoneTags"
                                />
                                <div class="input-group-prepend">
                                <button
                                    id="search"
                                    class="input-group-text bg-primary text-white"
                                    @click="searchPhoneTags"
                                >
                                    <i class="bx bx-search-alt search-icon"></i>
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="loading" class="row mt-4 mx-auto">
                        <div class="text-center">
                            <i class="bx bx-loader bx-lg bx-spin align-middle mr-2"></i> 
                            <p>Getting Contact Info</p>
                        </div>
                    </div>
                    <div class="row mt-4" v-if="tableData != 0">
                        <div class="col-sm-6 card">
                            <div class="card overflow-hidden border">
                                <div class="bg-soft-primary">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="text-primary p-3 text-center">
                                            <h5 class="text-primary">Profile</h5>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div class="card-body pt-0">
                                <div class="row">
                                    <div class="col-sm-4">
                                    <div class="avatar-md profile-user-wid mb-4 ">
                                        <img :src="profile_image" alt class="img-thumbnail rounded-circle" />
                                    </div>
                                    <h5 class="font-size-15 text-truncate">{{displayname}}</h5>
                                    <p class="text-muted mb-0 text-truncate"><i class="fas fa-envelope"></i>  {{email}}</p>
                                    </div>

                                    <div class="col-sm-8">
                                    <div class="pt-4">
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="text-center">
                                                    <h5 class="font-size-15">{{countrycode}}</h5>
                                                    <p class="text-muted mb-0">Country</p>
                                                </div>
                                            </div>
                                            <div class="col-6 left">
                                                <div class="text-center">
                                                    <h5 class="font-size-15">{{remain_count}}</h5>
                                                    <p class="text-muted mb-0">Count Tags</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <button v-b-modal.modal-add-to-project @click="listProject" class="btn btn-primary btn-sm float-right">
                                                Add to Project
                                                <i class="mdi mdi-arrow-right ml-1"></i>
                                            </button>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                <!-- end card-body -->
                            </div>
                            <div class="card mt-4">
                                <div class="card-body border rounded">
                                    <h4 class="card-title mb-4">Personal Information</h4>
                                    <div class="table-responsive mb-0">
                                    <table class="table">
                                        <tbody>
                                        <tr>
                                            <th scope="row">Name </th>
                                            <td>{{name}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">SurName </th>
                                            <td>{{surname}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Phone Number </th>
                                            <td>{{phonenumber}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">E-mail </th>
                                            <td>{{email}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Is Spam </th>
                                            <td>{{is_spam}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 card">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card border">
                                    <div class="card-body">
                                        <div class="row mt-1">
                                        <div class="col-sm-12 col-md-6">
                                            <h4 class="card-title">Name Tags Identification</h4>
                                        </div>
                                        <!-- Search -->
                                        <div class="col-sm-12 col-md-6">
                                            <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                            <label class="d-inline-flex align-items-center">
                                                Search:
                                                <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ml-2"
                                                ></b-form-input>
                                            </label>
                                            </div>
                                        </div>
                                        <!-- End search -->
                                        </div>
                                        <!-- Table -->
                                        <div class="table-responsive mb-0">
                                        <b-table
                                            :items="tableData"
                                            :fields="fields"
                                            responsive="sm"
                                            :per-page="perPage"
                                            :current-page="currentPage"
                                            :sort-by.sync="sortBy"
                                            :sort-desc.sync="sortDesc"
                                            :filter="filter"
                                            :filter-included-fields="filterOn"
                                            @filtered="onFiltered"
                                        ></b-table>
                                        </div>
                                        <div class="row">
                                        <div class="col">
                                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                            <ul class="pagination pagination-rounded mb-0">
                                                <!-- pagination -->
                                                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                            </ul>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            size="lg"
            ref="modal-add-to-project"
            :id="'modal-add-to-project'"
            centered
            title="Add To Project"
            title-class="font-18"
            hide-footer
        >
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row mt-1">
                                <div class="col-sm-12 col-md-6">
                                    <div id="tickets-table_length" class="dataTables_length">
                                        <label class="d-inline-flex align-items-center">
                                        Show&nbsp;&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-1"></b-form-select>&nbsp;&nbsp;entries
                                        </label>
                                    </div>
                                </div>
                                <!-- Search -->
                                <div class="col-sm-12 col-md-6">
                                    <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                        <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="form-control form-control ml-2"
                                        ></b-form-input>
                                        </label>
                                    </div>
                                </div>
                                <!-- End search -->
                            </div>
                            <!-- Table -->
                            <div class="table-responsive mb-0">
                                <b-table
                                :items="tableProject"
                                :fields="fieldsProject"
                                striped bordered
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                >
                                    <template #cell(target)="row"> 
                                        <div class="col-sm-12">
                                            <div class="media">
                                                <img
                                                    :src="urlimage+row.item.image_project"
                                                    class="mr-3 rounded-circle avatar-sm"
                                                    alt="user-pic"
                                                    />
                                                <div class="media-body">
                                                <b> {{row.item.title}}</b> <br> 
                                                <p class="text-secondary">Updated : {{formatDate(row.item.updated_at)}} </p> 
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template #cell(description)="row">
                                        <p>{{row.item.description}}</p>
                                        <p>{{row.item.other_description}}</p>
                                    </template>
                                    <template #cell(actions)="row">
                                        <b-button class="btn-sm" @click="addContact(row.item.id_private_data)" variant="primary" >
                                            <i class="bx bx-plus"></i> 
                                        </b-button>
                                    </template>
                                </b-table>
                            </div>
                            <div class="row">
                                <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                    <b-pagination v-model="currentPage" :total-rows="rowsProject" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import PhoneService from "@/helpers/phone.service.js";
import TargetService from "@/helpers/target-profile.service.js";
import SocmedService from "@/helpers/socmed.service.js";

export default {
    page: {
        title: "Tools Instagram",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            search: false,
            searchKey: "",
            name:"",
            surname:"",
            displayname:"",
            countrycode:"",
            email:"",
            phonenumber:"",
            profile_image:"",
            remain_count:"",
            is_spam:"",
            search:false,
            title: "PHONE TOOLS",
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: "Phone Tags",
                active: true
                }
            ],
            tableProject: [],
            tableData: [],
            tags_res: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "no",
            sortDesc: false,
            fields: [
                { key: "no", label: '#', sortable: true },
                { key: "tag", label: 'Tag', sortable: true },
            ],
            fieldsProject: [
                { key: "target", label: 'Target', sortable: true },
                { key: "description", label: 'Description', sortable: true },
                { key: "actions", label: 'Action' },
            ]
        }
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
        rowsProject() {
            return this.tableProject.length;
        },
    },
    methods:{
        searchPhoneTags() {
            const data = {
                'phone': this.searchKey,
            };
            if (this.searchKey != "") {
                let num = 1;
                this.search = true;    
                this.loading = true;
                this.searchResult = []
                this.tableData = []
                PhoneService.tags(data)
                .then((response) => {
                    this.name = response.data.output.name;
                    this.surname = response.data.output.surname;
                    this.email = response.data.output.email;
                    this.displayname = response.data.output.displayname;
                    this.phonenumber = response.data.output.phonenumber;
                    this.profile_image = response.data.output.profile_image;
                    this.remain_count = response.data.output.remain_count;
                    this.is_spam = response.data.output.is_spam;
                    this.countrycode = response.data.output.countrycode;
                    this.tags_res = response.data.output.tags;
                    response.data.output.tags.forEach(element => {
                        this.tableData.push({'no': num, 'tag' : element});
                        num++;
                    });
                    this.loading = false;  
                })
                .catch((err) => {
                    console.log(err);
                    this.search = false;
                    this.loading = false;  
                });
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        formatDate(value){
            return moment(value).format("dddd, YYYY-MM-DD hh:mm");
        },
        listProject(){
            TargetService.getAllTarget()
            .then(response => {
                response.data.data.forEach(element => {
                    this.tableProject.push(element);
                });
            })
            .catch(err => {
                console.log(err);
            })
        },
        async addContact(id_private_data){
            const data = {
                'name' : this.name,
                'surname' : this.surname,
                'phone_number' : this.phonenumber,
                'country_code' : this.countrycode,
                'display_name' : this.displayname,
                'profile_image' : this.profile_image,
                'email' : this.email,
                'is_spam' : this.is_spam,
                'remain_count' : this.remain_count,
                'tags' : JSON.stringify(this.tags_res),
            }
            PhoneService.add_contact(data)
            .then(response => {
                this.updatePrivateData(id_private_data ,response.data.data.id_contact)
                Vue.swal({
                    position: "top-end",
                    icon: "success",
                    title: "Success Add To Project",
                    showConfirmButton: false,
                    timer: 2000
                });
                this.$router.push('/project');
            })
            .catch(err => {
                console.log(err);
            })
        },
        updatePrivateData(id_private, id_contact){
            const data = {
                'id_contact' : id_contact
            }
            SocmedService.updatePrivateData(id_private, data)
            .then(response => {
                console.log(response);
            })
            .catch(err => {
                console.log(err);
            })
        }
    },
    mounted(){
        this.totalRows = this.items.length;
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>